import { createContext, useContext, useEffect, useState } from 'react';

const GeoContext = createContext(null);

export const GeoProvider = ({ children }) => {
  const [country, setCountry] = useState(null); // null = ещё грузится
  useEffect(() => {
    fetch('/api/geo')
      .then(r => r.json())
      .then(d => setCountry(d.country || 'RU'))
      .catch(() => setCountry('RU'));
  }, []);
  return <GeoContext.Provider value={country}>{children}</GeoContext.Provider>;
};

export function useGeo() {
  return useContext(GeoContext);
}

// Парсит "36.8516, 28.2807" → { lat, lng } или null если неверный формат
export function parseCoords(coords) {
  if (!coords) return null;
  const m = coords.trim().match(/^(-?\d+\.?\d*)\s*,\s*(-?\d+\.?\d*)$/);
  if (!m) return null;
  return { lat: parseFloat(m[1]), lng: parseFloat(m[2]) };
}

// Название страны по коду ISO для формы записи
export const COUNTRY_NAMES = {
  RU: 'Россия', BY: 'Беларусь', KZ: 'Казахстан', UA: 'Украина',
  DE: 'Германия', FR: 'Франция', GB: 'Великобритания', IT: 'Италия',
  ES: 'Испания', NL: 'Нидерланды', PL: 'Польша', CZ: 'Чехия',
  AT: 'Австрия', CH: 'Швейцария', SE: 'Швеция', NO: 'Норвегия',
  FI: 'Финляндия', DK: 'Дания', TR: 'Турция', GR: 'Греция',
  IL: 'Израиль', AE: 'ОАЭ', US: 'США', CA: 'Канада', AU: 'Австралия',
};

// null/RU/BY → Яндекс; остальные → Google
export function mapUrl(query, country) {
  const q = encodeURIComponent(query);
  if (!country || country === 'RU' || country === 'BY') return `https://yandex.ru/maps/?text=${q}`;
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
}

export function coordsMapUrl(coords, country) {
  const p = parseCoords(coords);
  if (!p) return coords ? mapUrl(coords, country) : '#';
  const { lat, lng } = p;
  if (!country || country === 'RU' || country === 'BY') return `https://yandex.ru/maps/?ll=${lng},${lat}&z=15&pt=${lng},${lat}`;
  return `https://www.google.com/maps?q=${lat},${lng}`;
}
